
import {Component, Vue} from "vue-property-decorator";
import Evaluate from "@/views/评测管理/view/土地评测/component/evaluate.vue";
import Climate from "@/views/评测管理/view/土地评测/component/climate.vue";
import Quality from "@/views/评测管理/view/土地评测/component/quality.vue";
import Topographic from "@/views/评测管理/view/土地评测/component/topographic.vue";
import nyNetwork from "@/api/nyBaseNetwork";
import DZModelClimate from "@/views/评测管理/model/DZModelClimate";
import DZModelQuality from "@/views/评测管理/model/DZModelQuality";
import DZModelTopographic from "@/views/评测管理/model/DZModelTopographic";
import DZModelEvaluate from "@/views/评测管理/model/DZModelEvaluate";

@Component({
  components: {Topographic, Evaluate ,Climate, Quality}
})
export default class Index extends Vue {

  active = 'A'

  id = "";

  dic = [];

  created(){
    this.id = this.$route.query.id as string;
  }

  mounted(){
    this.net_list_dic_all();
    this.get_climate();
    this.get_evaluate();
    this.get_quality();
    this.get_topographic();
  }

  net_list_dic_all(){
    nyNetwork.get("字典列表全部",{}, data => {
      this.dic = data
    })
  }

  update_climate(m){nyNetwork.net("修改气候降雨",m, data => {})}

  update_quality(m){nyNetwork.net("修改土质土壤",m, data => {})}

  update_topographic(m){nyNetwork.net("修改地形地貌",m, data => {})}

  update_evaluate(m){nyNetwork.net("修改土地测评",m, data => {})}

  climate = new DZModelClimate();

  quality = new DZModelQuality();

  topographic = new DZModelTopographic();

  evaluate = new DZModelEvaluate();

  get_climate(){
    nyNetwork.net("查询气候降雨",{land:this.id}, data => {
      this.climate = data
      this.climate.landId = this.id
    })
  }

  get_quality(){
    nyNetwork.net("查询土地测评",{land:this.id}, data => {
      this.evaluate = data
      this.evaluate.landId = this.id
    })
  }

  get_topographic(){
    nyNetwork.net("查询土质土壤",{land:this.id}, data => {
      this.quality = data
      this.quality.landId = this.id
    })
  }

  get_evaluate(){
    nyNetwork.net("查询地形地貌",{land:this.id}, data => {
      this.topographic = data
      this.topographic.landId = this.id
    })
  }

}
